module.exports = {"linkedInLink":"https://www.linkedin.com/company/codeshine","clutchLink":"https://clutch.co/profile/codeshine"}